import React from "react";
import SectionHeader from "./SectionHeader";

const AUDIENCE = [
  {
    t: "Law firms",
    d: "Scale litigation and advisory capacity without scaling headcount. Consistent, cited work product across teams and offices.",
  },
  {
    t: "Advocates & chambers",
    d: "Prepare submissions grounded in authority and walk into court knowing the latest law and the next listing.",
  },
  {
    t: "CAs & tax practitioners",
    d: "Answer notices and assessments quickly, with notifications and circulars monitored for every client.",
  },
  {
    t: "In-house legal & tax teams",
    d: "Track every dispute across forums and states, see what’s next, and brief external counsel with research already done.",
  },
];

const WhoItsFor = () => (
  <section className="vd-section">
    <div className="container">
      <SectionHeader
        eyebrow="WHO IT’S FOR"
        title="Made for the people who answer to the court."
      />
      <div className="row g-4">
        {AUDIENCE.map((a) => (
          <div className="col-md-6 col-lg-3" key={a.t}>
            <div className="vd-tile">
              <h3>{a.t}</h3>
              <p>{a.d}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhoItsFor;
